export enum UserDetailsTabTypeEnum {
    SETTINGS = 'settings',
    PROJECTS = 'projects',
    EVENTS = 'events',
    ACTIVITY = 'activity',
    PUBLIC_KEYS = 'public-keys',
    BILLING = 'billing',
}
